var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":_vm.title}},[_c('hospedajes-reports-table',{key:'sent-hospedajes-reports-table',attrs:{"items":_vm.items,"loading":_vm.loading,"status":'SENT'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }